export default "__VITE_ASSET__DP6iL7TF__"